import animate from './animate';

function scrollTo (offsetNumber) {
	let ofTop;
	if ($.isNumeric(offsetNumber)) {
		ofTop = offsetNumber;
	} else {
		ofTop = $(offsetNumber).offset().top;
	}

	$('html, body').stop().animate({
		scrollTop: ofTop
	}, 700);
}

(function ($) {
	let $topBtn = $('.js-top');
	let $chatBtn = $('.js-bwidget');
	let $window = $(window);

	$('.js-down').on('click', () => {
		scrollTo('.js-down-section');
	});
	//
	// $('.js-anchors').on('click', '.js-anchors-item', function () {
	// 	scrollTo($(this).attr('href'));
	// });
	//
	// $('.js-anchor').on('click', function () {
	// 	scrollTo($(this).attr('href'));
	// });

	/* $('.js-binotel').on('click', () => {
		$('#bingc-phone-button-tooltip').trigger('click');
	}); */

	$('body').on('click', '.js-mfp-close', () => {
		$.magnificPopup.close();
	});

	$chatBtn.on('touchend mouseleave mousedown', (e) => {
		if (e.type === 'touchend') {
			$chatBtn.toggleClass('is-open');
		}

		if (e.type === 'mouseleave') {
			$chatBtn.removeClass('is-open');
		}

		if (e.type === 'mousedown') {
			$chatBtn.addClass('is-open');
		}
	});

	// $topBtn.on('click', () => {
	// 	scrollTo(0);
	// });

	$window.on('scroll', function () {
		if ($window.scrollTop() > 100) {
			$topBtn.addClass('is-visible');
		} else {
			$topBtn.removeClass('is-visible');
		}
	});

	let page = 1;

	$('.js-portfolio').on('click', function () {
		let it = $(this);
		let ajax = it.data('ajax');
		let target = it.data('target');

		if (ajax && target && !it.hasClass('disabled')) {
			it.addClass('disabled').css({'opacity': '0.35'});

			$.ajax({
				url: '/ajax/general/' + ajax,
				type: 'POST',
				dataType: 'JSON',
				data: {
					page: page
				},
				success: function (data) {
					if (data.success) {
						const $html = $(data.html);
						animate($html);
						$html.appendTo(target);
						if (data.remove) {
							it.remove();
						}
					}
					window.lazyLoad.observe();
					it.removeClass('disabled').css({'opacity': '1'});
					page = page + 1;
				}
			});
		}
	});

	$('body').on('click', '.js-button-video', function () {
		if (!$(this).closest('form').valid()) return false;
		$(this).closest('form').submit();
		$.magnificPopup.close();
		setTimeout(function () {
			let nowHours = new Date().getHours();
			let nowDay = new Date().getDay();
			let nowWork = ((nowDay > 0 && nowDay < 6) && (nowHours >= 9 && nowHours < 18));
			let video = (nowWork) ? 'https://www.youtube.com/watch?v=R7_3g-EM04U' : 'https://www.youtube.com/watch?v=uTyEeSGoLDg';
			$.magnificPopup.open({
				items: [
					{
						src: video
					}
				],
				mainClass: 'zoom-in',
				type: 'iframe',
				closeBtnInside: true,
				autoFocusLast: false,
				fixedContentPos: false,
				removalDelay: 200,
				iframe: {
					markup: '<div class="magnific-popup mfp-iframe-scaler">' +
					'<div class="mfp-close"></div>' +
					'<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
					'</div>'
				}
			});
		}, 250);
	});
})(window.jQuery);



// WEBPACK FOOTER //
// ./src/js/_modules/buttons.js